import React, { FC, useState, useMemo, useEffect } from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';
import { DailyAgendaActions } from '../actions/actions';
import { DailyAgendaActionsProvider } from '../hooks/useDailyAgendaActions';
import { Widget as WidgetComponent } from './Widget';
import { WidgetViewModelProvider } from '../hooks/useWidgetViewModel';
import { WidgetViewModel } from '../viewModel/viewModel';
import { DatePickerProvider } from '../hooks/useDatePicker';

const parseSelectedDate = (selectedDate: string) => {
  return new Date(`${selectedDate}T00:00:00`);
};

const Widget: FC<
  WidgetProps<{
    viewModel: WidgetViewModel;
    actions: DailyAgendaActions;
  }>
> = ({ actions, viewModel }) => {
  const viewModelSelectedDate = viewModel.datePickerViewModel.selectedDate;

  const [currentDate, setCurrentDate] = useState(() =>
    parseSelectedDate(viewModelSelectedDate!),
  );
  const [headerSize, setHeaderSize] = useState<{
    width?: number;
    height?: number;
  }>({});
  const contextValue = useMemo(
    () => ({ currentDate, setCurrentDate, headerSize, setHeaderSize }),
    [currentDate, headerSize],
  );

  useEffect(() => {
    setCurrentDate(parseSelectedDate(viewModelSelectedDate!));
  }, [viewModelSelectedDate]);

  return (
    <WidgetViewModelProvider value={viewModel}>
      <DailyAgendaActionsProvider value={actions}>
        <DatePickerProvider value={contextValue}>
          <WidgetComponent />
        </DatePickerProvider>
      </DailyAgendaActionsProvider>
    </WidgetViewModelProvider>
  );
};

export default Widget;
